import * as React from 'react';
import cn from 'classnames';
import { Waiver } from '../../types/waiver';
import styles from './work-item-details.module.css';
import { Modal } from '../../components/modal/Modal';
import { NumericInput } from '../../components/forms/Input';

const columnStyle = 'col-sm-5';
const columnSpacerStyle = 'col-sm-2';

interface WaiverAssociationModalProps {
  waiver: Waiver | null;
  onSubmit: (waiver: Waiver, newChangeEventId: number) => void;
  onClose: () => void;
}

interface State {
  newChangeEventId: number | undefined;
}

const initialState: State = {
  newChangeEventId: undefined,
};

export class WaiverAssociationModal extends React.Component<
  WaiverAssociationModalProps,
  State
> {
  state = initialState;

  onOpen = () => {
    this.setState(initialState);
  };

  onSubmit = () => {
    if (this.props.waiver && this.state.newChangeEventId !== undefined) {
      this.props.onSubmit(this.props.waiver, this.state.newChangeEventId);
      this.props.onClose();
    }
  };

  updateInput = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const newChangeEventId = e.currentTarget.value
      ? parseInt(e.currentTarget.value)
      : undefined;
    this.setState({ newChangeEventId });
  };

  render() {
    if (!this.props.waiver) {
      return null;
    }
    const waiver: Waiver = this.props.waiver;

    return (
      <Modal
        isOpen={!!waiver}
        onOpen={this.onOpen}
        onClose={this.props.onClose}
        onSubmit={this.onSubmit}
        title="Change Waiver Association"
      >
        <TextLine textKey="Waiver ID" textValue={waiver.id} />
        <TextLine textKey="Waiver Name" textValue={waiver.name} />
        <TextLine
          textKey="Current Notification ID"
          textValue={waiver.changeEventId || 'None'}
        />
        <div className={cn('row', styles.modalInputRow)}>
          <div className={cn(styles.modalTextKey, columnStyle)}>
            New Notification ID:
          </div>
          <div className={cn(columnStyle)}>
            <NumericInput
              placeholder="12345"
              name="newChangeEventId"
              value={this.state.newChangeEventId}
              onChange={this.updateInput}
            />
          </div>
          <div className={cn(columnSpacerStyle)} />
        </div>
      </Modal>
    );
  }
}

interface TextLineProps {
  textKey: string;
  textValue: string | number | null;
}

const TextLine: React.FC<TextLineProps> = ({ textKey, textValue }) => (
  <div className={cn('row')}>
    <div className={cn(styles.modalTextKey, columnStyle)}>{textKey}:</div>
    <div className={cn(styles.modalTextValue, columnStyle)}>
      {textValue || 'None'}
    </div>
    <div className={cn(columnSpacerStyle)} />
  </div>
);

export default WaiverAssociationModal;
